// src/catalog.fixed.ts
// Lightweight, non-destructive display-name fixes for the front end.
// We import your auto-generated catalog and only adjust displayName
// for a few items. IDs and alias lists remain exactly as in your CSV.

import { CATALOG_SUBJECTS, CATALOG_PROCEDURES } from "./catalog";

export const CATALOG_SUBJECTS_FIXED = CATALOG_SUBJECTS;

export const CATALOG_PROCEDURES_FIXED = CATALOG_PROCEDURES.map((p) => {
  const copy = { ...p };
  switch (copy.id) {
    case "arrythmia-management":
      copy.displayName = "Arrhythmia Management";
      break;
    case "obesity-and-metabollic-health-management":
      copy.displayName = "Obesity and Metabolic Health Management";
      break;
    case "gram-s-stained-smear-interpretation":
      copy.displayName = "Gram-stained Smear Interpretation";
      break;
    case "koh-examination-of-scraping-for-fungus":
      copy.displayName = "KOH Examination of Scraping for Fungus";
      break;
    case "iv-infusion-and-drip-rate-calculation":
      copy.displayName = "IV Infusion and Drip Rate Calculation";
      break;
    case "copd":
      copy.displayName = "COPD";
      break;
    case "dlco-evaluation":
      copy.displayName = "DLCO Evaluation";
      break;
    default:
      // leave all others as-is (including Visual Acuity and any alias collisions)
      break;
  }
  return copy;
});
